import { MsalProvider } from '@azure/msal-react';
import { PropsWithChildren } from 'react';

import { msalInstance } from '@shared/providers/AzureAuthProvider/authConfig.ts';

export function AzureAuthProvider({ children }: PropsWithChildren) {
  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
}
